<template>
  

<section class="kc-elm kc-css-910526 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-689270 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-207440 ">
                  <div class="wr deb derb dea dera none nonea">
                     <slot name="title">
                        <h2 class="t1">How It Is </h2>
                        <h2 class="t2">Going</h2>
                     </slot>
                        
                     <slot name="subtitle">
                        <p class="t3">We offer professional web design services at affordable rates to help your business attract more visitors and keep them on your site!</p>
                     </slot>
                  </div>
               </div>
               <div class="kc-elm kc-css-988178 kc_row kc_row_inner sst-flex-row-inner how_it_is">
                  <div class="kc-elm kc-css-782457 kc_col-of-5 kc_column_inner kc_col-of-5">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-854623 template18 kc-pc-loaded">
                           <div class="icon_box wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
                              <div class="bgr_icon"><i :class="steps.step1.icon" style="font-size:30px; width:30px; height:30px"></i></div>
                              <div class="c_text" style=" height: 30px; margin-top: -30px; font-size: 30px; ">01</div>
                           </div>
                           <div class="cont_box">
                              <div class="title wow animated bounceInUp" data-wow-duration="2s" data-wow-delay="0s">{{ steps.step1.name }}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-452986 kc_col-of-5 kc_column_inner kc_col-of-5">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-283715 template18 kc-pc-loaded">
                           <div class="icon_box wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
                              <div class="bgr_icon"><i :class="steps.step2.icon" style="font-size:30px; width:30px; height:30px"></i></div>
                              <div class="c_text" style=" height: 30px; margin-top: -30px; font-size: 30px; ">02</div>
                           </div>
                           <div class="cont_box">
                              <div class="title wow animated bounceInUp" data-wow-duration="2s" data-wow-delay="0s">{{ steps.step2.name }}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-613122 kc_col-of-5 kc_column_inner kc_col-of-5">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-184330 template18 kc-pc-loaded">
                           <div class="icon_box wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
                              <div class="bgr_icon"><i :class="steps.step3.icon" style="font-size:30px; width:30px; height:30px"></i></div>
                              <div class="c_text" style=" height: 30px; margin-top: -30px; font-size: 30px; ">03</div>
                           </div>
                           <div class="cont_box">
                              <div class="title wow animated bounceInUp" data-wow-duration="2s" data-wow-delay="0s">{{ steps.step3.name }}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-857236 kc_col-of-5 kc_column_inner kc_col-of-5">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-475355 template18 kc-pc-loaded">
                           <div class="icon_box wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
                              <div class="bgr_icon"><i :class="steps.step4.icon" style="font-size:30px; width:30px; height:30px"></i></div>
                              <div class="c_text" style=" height: 30px; margin-top: -30px; font-size: 30px; ">04</div>
                           </div>
                           <div class="cont_box">
                              <div class="title wow animated bounceInUp" data-wow-duration="2s" data-wow-delay="0s">{{ steps.step4.name }}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-130794 kc_col-of-5 kc_column_inner kc_col-of-5">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-540183 template18 kc-pc-loaded">
                           <div class="icon_box wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
                              <div class="bgr_icon"><i :class="steps.step5.icon" style="font-size:30px; width:30px; height:30px"></i></div>
                              <div class="c_text" style=" height: 30px; margin-top: -30px; font-size: 30px; ">05</div>
                           </div>
                           <div class="cont_box">
                              <div class="title wow animated bounceInUp" data-wow-duration="2s" data-wow-delay="0s">{{ steps.step5.name }}</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "WhoItWork",
  props: ["title", "subtitle", "header", "steps"],
  data() {
    return {
      msg: "WhoItWork"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
div.kc_col-of-5{width:20%;float:left;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
[class^="nat-"]{font-family:'native'!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.nat-computer-design-2:before{content:"\ebeb";}
.nat-graphic-design:before{content:"\ebfd";}
.nat-light-bulb2:before{content:"\ec0e";}
.nat-stats-1:before{content:"\eb3f";}
.nat-rocket2:before{content:"\ec25";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
section{display:block;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
i{font-style:italic;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box i{transition:all 300ms ease-in;}
.ssc_icon_box,.ssc_icon_box .bgr_icon,.ssc_icon_box .bgr_icon i,.ssc_icon_box .c_text,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title{transition:all 350ms ease-in;}
.ssc_icon_box .bgr_icon{width:70px;position:relative;z-index:1;}
.ssc_icon_box .bgr_icon i{display:block;}
.ssc_icon_box .c_text{color:#ef5229;position:relative;z-index:9;text-align:center;font-size:30px;font-weight:700;}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box.template18{text-align:center;}
.ssc_icon_box.template18 .title{margin-top:20px;}
.ssc_icon_box.template18 .bgr_icon i{margin:0 auto;}
.ssc_icon_box.template18 .c_text{position:absolute;left:0;top:0;}
.ssc_icon_box.template18 .icon_box{width:100%;position:relative;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:480px){
.ssc_icon_box .bgr_icon i,.ssc_icon_box .c_text{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t3{font-size:20px;line-height:26px;padding-top:20px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-689270{width:100%;}
body.kc-css-system .kc-css-782457{width:20%;}
body.kc-css-system .kc-css-452986{width:20%;}
body.kc-css-system .kc-css-613122{width:20%;}
body.kc-css-system .kc-css-857236{width:20%;}
body.kc-css-system .kc-css-130794{width:20%;}
}
body.kc-css-system .kc-css-910526{background:transparent url(../../assets/images/steps.png) 50% 90%/auto no-repeat scroll;padding-top:120px;z-index:3;}
body.kc-css-system .kc-css-910526 .befbgr:nth-child(1){text-align:center;}
body.kc-css-system .kc-css-207440{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-207440 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-207440 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-207440 .t1{text-align:center;text-transform:full-size-kana;display:inline;}
body.kc-css-system .kc-css-207440 .t2{color:#ED7D31;display:inline;}
body.kc-css-system .kc-css-207440 .t3{padding-top:17px;padding-right:24%;padding-left:24%;}
body.kc-css-system .kc-css-988178{background:transparent url(../../assets/images/Vector-1.png) center top/auto no-repeat scroll;margin-top:80px;margin-bottom:40px;}
body.kc-css-system .kc-css-782457{padding-top:13px;}
body.kc-css-system .kc-css-854623{text-align:center;width:100%;margin-top:-50px;margin-left:10px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-854623 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-854623 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-854623 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-854623 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-854623 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-854623 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-854623 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-854623 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-854623 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-854623 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-854623 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:8px;}
body.kc-css-system .kc-css-854623 .cont_box{text-align:center;}
body.kc-css-system .kc-css-854623:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-452986{padding-top:100px;}
body.kc-css-system .kc-css-452986{padding-top:121px;}
body.kc-css-system .kc-css-283715{text-align:center;width:100%;margin-left:10px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-283715 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-283715 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-283715 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-283715 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-283715 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-283715 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-283715 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-283715 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-283715 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-283715 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-283715 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:8px;}
body.kc-css-system .kc-css-283715 .cont_box{text-align:center;}
body.kc-css-system .kc-css-283715:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-613122{padding-top:19px;}
body.kc-css-system .kc-css-184330{text-align:center;width:100%;margin-top:-15px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-184330 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-184330 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-184330 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-184330 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-184330 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-184330 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-184330 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-184330 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-184330 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-184330 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-184330 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:8px;}
body.kc-css-system .kc-css-184330 .cont_box{text-align:center;}
body.kc-css-system .kc-css-184330:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-857236{padding-top:100px;}
body.kc-css-system .kc-css-857236{padding-top:120px;}
body.kc-css-system .kc-css-475355{text-align:center;width:100%;margin-top:-15px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-475355 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-475355 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-475355 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-475355 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-475355 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-475355 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-475355 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-475355 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-475355 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-475355 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-475355 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:8px;}
body.kc-css-system .kc-css-475355 .cont_box{text-align:center;}
body.kc-css-system .kc-css-475355:hover .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-130794{padding-top:69px;}
body.kc-css-system .kc-css-540183{text-align:center;width:100%;margin-top:-15px;padding-top:0px;padding-bottom:30px;}
body.kc-css-system .kc-css-540183 .c_text{color:rgba(34, 34, 34, 0.30);}
body.kc-css-system .kc-css-540183 .c_text{font-family:Montserrat;font-weight:500;}
body.kc-css-system .kc-css-540183 .c_text{width:60px;height:30px;margin-top:-105px!important;padding-top:45px;}
body.kc-css-system .kc-css-540183 .icon_box{background:#ffffff;display:inline-block;width:70px;height:70px;border:2px solid #ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-540183 .bgr_icon{color:#222222;}
body.kc-css-system .kc-css-540183 .bgr_icon i{font-size:35px;}
body.kc-css-system .kc-css-540183 .bgr_icon i{line-height:33px;}
body.kc-css-system .kc-css-540183 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-540183 .bgr_icon i{height:70px!important;}
body.kc-css-system .kc-css-540183 .bgr_icon{padding-top:17px;padding-bottom:15px;}
body.kc-css-system .kc-css-540183 .title{color:#222222;font-size:20px;line-height:26px;font-weight:500;text-align:center;text-transform:full-size-kana;margin-top:8px;}
body.kc-css-system .kc-css-540183 .cont_box{text-align:center;}
body.kc-css-system .kc-css-540183:hover .bgr_icon{color:#ED7D31;}
@media only screen and (max-width:768px){
body.kc-css-system .kc-css-207440 .deb:before{display:none;}
body.kc-css-system .kc-css-207440 .deb:after{display:none;}
body.kc-css-system .kc-css-854623{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-854623 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-854623 .icon_box{margin-top:0px;margin-left:20px;}
body.kc-css-system .kc-css-854623 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-283715{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-283715 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-283715 .icon_box{margin-top:0px;margin-right:20px;margin-left:20px;}
body.kc-css-system .kc-css-283715 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-184330{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-184330 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-184330 .icon_box{margin-top:0px;margin-right:20px;margin-left:20px;}
body.kc-css-system .kc-css-184330 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-475355{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-475355 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-475355 .icon_box{margin-top:0px;margin-right:20px;margin-left:20px;}
body.kc-css-system .kc-css-475355 .cont_box{display:inline-block;}
body.kc-css-system .kc-css-540183{text-align:left;margin-top:0px;margin-left:15px;}
body.kc-css-system .kc-css-540183 .c_text{margin-top:-32px!important;margin-left:-70px!important;}
body.kc-css-system .kc-css-540183 .icon_box{margin-top:0px;margin-left:20px;}
body.kc-css-system .kc-css-540183 .cont_box{display:inline-block;}
}
@media only screen and (max-width:667px){
body.kc-css-system .kc-css-207440 .t3{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-854623{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-854623 .title{padding-left:10px;}
body.kc-css-system .kc-css-283715{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-283715 .title{padding-left:10px;}
body.kc-css-system .kc-css-184330{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-184330 .title{padding-left:10px;}
body.kc-css-system .kc-css-475355{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-475355 .title{padding-left:10px;}
body.kc-css-system .kc-css-540183{display:flex;width:100%;margin-left:0px;padding-bottom:30px;padding-left:15%;}
body.kc-css-system .kc-css-540183 .title{padding-left:10px;}
}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-689270 .kc-col-container{width:100%;}
}
@media only screen and (max-width:999px){
/* body.kc-css-system .kc-css-689270 .kc-col-container{padding-right:15px;} */
body.kc-css-system .kc-css-689270{margin-left:0%;width:100%;}
}
@media only screen and (max-width:767px){
body.kc-css-system .kc-css-988178{background:#ffffff;}
body.kc-css-system .kc-css-452986{padding-top:0px;}
body.kc-css-system .kc-css-452986{padding-top:0px;}
body.kc-css-system .kc-css-613122{padding-top:0px;}
body.kc-css-system .kc-css-857236{padding-top:15px;}
body.kc-css-system .kc-css-857236{padding-top:0px;}
body.kc-css-system .kc-css-130794{padding-top:0px;}
body.kc-css-system .kc-css-130794{padding-top:0px;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-910526{padding-top:25px;}
body.kc-css-system .kc-css-782457{text-align:center;padding-top:15px;}
body.kc-css-system .kc-css-854623{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-854623 .title{font-size:16px;padding-left:25px;}
body.kc-css-system .kc-css-854623 .cont_box{text-align:center;}
body.kc-css-system .kc-css-452986{padding-top:0px;}
body.kc-css-system .kc-css-283715{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-283715 .title{font-size:16px;padding-left:10px;}
body.kc-css-system .kc-css-283715 .cont_box{text-align:center;}
body.kc-css-system .kc-css-613122{padding-top:15px;}
body.kc-css-system .kc-css-184330{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-184330 .title{font-size:16px;padding-left:10px;}
body.kc-css-system .kc-css-184330 .cont_box{text-align:center;}
body.kc-css-system .kc-css-857236{padding-top:15px;}
body.kc-css-system .kc-css-475355{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-475355 .title{font-size:16px;padding-left:10px;}
body.kc-css-system .kc-css-475355 .cont_box{text-align:center;}
body.kc-css-system .kc-css-130794{padding-top:15px;}
body.kc-css-system .kc-css-540183{text-align:center;display:flex;width:100%;padding-bottom:30px;}
body.kc-css-system .kc-css-540183 .title{font-size:16px;margin-right:-5px;padding-left:10px;}
body.kc-css-system .kc-css-540183 .cont_box{text-align:center;}
}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'native';src:url(../../assets/fonts/native.eot?3hn4ip);src:url('../../assets/fonts/native.eot?3hn4ip#iefix') format('embedded-opentype'),url(../../assets/fonts/native.ttf?3hn4ip) format('truetype'),url(../../assets/fonts/native.woff?3hn4ip) format('woff'),url('../../assets/fonts/native.svg?3hn4ip#native') format('svg');font-weight:400;font-style:normal;}
</style>



// WEBPACK FOOTER //
// src/components/Blocks/HowItWork.vue